// extracted by mini-css-extract-plugin
export default {"summary-container":"CustomerReportSummary_summary-container__VbW6U","summary-ctas":"CustomerReportSummary_summary-ctas__lRtnU"};